import { agencyid, getBtnStatusClass } from "@phoenixreisen/form";
import { authAgency } from "../../../shared/functions/booking";
import { logError } from "../../../shared/functions/misc";
import Context from "../shared/context";
import User from "@phoenixreisen/user";
import Config from "../../../config";
import striptags from "striptags";
import m from "mithril";
import { setHasTokenRenewedAt } from "@phoenixreisen/frontend-lib";
export class View {
    failure = null;
    success = false;
    submitting = false;
    fields = {
        agencyid: agencyid(true, (input) => {
            this.success = false;
            this.failure = null;
            return input;
        }),
    };
    async submit(e) {
        e?.preventDefault?.();
        this.failure = null;
        this.success = false;
        const { agencyid } = this.fields;
        agencyid.validate(agencyid.value());
        if (!agencyid.complaint) {
            try {
                this.submitting = true;
                await authAgency(agencyid.value());
                this.success = true;
                setHasTokenRenewedAt();
            }
            catch (e) {
                this.failure = e;
                logError(e);
            }
            finally {
                this.submitting = false;
                m.redraw();
            }
        }
    }
    view() {
        const { urls, html } = Config;
        const { agencyid } = this.fields;
        const { success, failure, submitting } = this;
        const { webtexte: wt, storageIsNotAvailable } = Context;
        try {
            const btnStatusClass = getBtnStatusClass(success, failure);
            return (m("form", { class: "form login-form jackInTheBox animated fast", onsubmit: (e) => this.submit(e) },
                !User.online ? (m("article", { class: "alert alert--danger alert--icon" },
                    m("i", { class: "fas fa-exclamation-triangle" }),
                    "Sie haben zurzeit keine Verbindung zum Internet.")) : (!!wt?.["login__infosatz"] &&
                    !storageIsNotAvailable && (m("p", { class: "alert alert--info alert--icon mb3" },
                    m("i", { class: "fas fa-info-circle ml1 mr2" }),
                    m("small", null, m.trust(striptags(wt["login__infosatz"], html.allowed)))))),
                !!this.failure && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--danger alert--icon mb3" },
                        m("i", { class: "fas fa-exclamation-triangle mr2" }),
                        this.failure.code === 400
                            ? "Es wurden zu viele Anmeldeversuche registriert. Bitte warten Sie einige Minuten, bevor Sie es erneut versuchen."
                            : "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."))),
                this.success && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--success alert--icon mb3" },
                        m("i", { class: "fas fa-check mr2" }),
                        "Bitte pr\u00FCfen Sie Ihre Email. Sie sollten einen Link erhalten haben."))),
                m("label", { class: "textfield custom-field" },
                    m("input", { type: "text", name: "first", maxLength: "6", autocomplete: "first", value: agencyid.value(), placeholder: "z.B. 123456", disabled: storageIsNotAvailable || !User.online, oninput: (e) => agencyid.validate(e.target.value.replace(/\s/g, "")) }),
                    m("span", { class: `textfield__label ${agencyid.complaint ? "alert--warning" : ""}` }, !agencyid.complaint
                        ? "Agenturnummer"
                        : "Eine Agenturnr. besteht aus 6 Ziffern")),
                m("div", { class: "tr" },
                    m("a", { href: "https://www.phoenixreisen.com/profibereich.html", title: "zu unserem Reiseb\u00FCro-/Profibereich", target: "_blank", rel: "noopener noreferrer", class: "btn btn--link desktop-only mr2" },
                        m("i", { class: "fas fa-external-link-alt mr1" }),
                        "Profibereich"),
                    m("a", { href: urls.AGENCY_HELP, class: "btn btn--link mr2", title: "Hilfe f\u00FCr Reiseb\u00FCros", target: "_blank", rel: "noopener noreferrer" },
                        m("i", { class: "fas fa-question-circle mr1" }),
                        m("span", null, "Hilfe")),
                    m("button", { type: "submit", class: `btn ${btnStatusClass}`, disabled: submitting || success || storageIsNotAvailable || !User.online },
                        submitting ? (m("i", { class: "fas fa-spinner fa-spin mr2" })) : (m("i", { class: "fas fa-share-square mr2" })),
                        !success ? (m("span", null, "Login beantragen")) : (m("span", null, "Login versendet"))))));
        }
        catch (error) {
            logError(error);
            location.href = urls.FE_ERROR;
        }
    }
}
export default View;
